export enum JobOrderScoreCategoryEnum {
  RequiredSkills = 'Wymagane umiejętności',
  PreferredSkills = 'Mile widziane umiejętności',
  Languages = 'Angielski',
  Salary = 'Stawka',
  WorkMode = 'Tryb pracy',
  Availability = 'Twoja dostępność',
  YearsInRole = 'Doświadczenie w roli (lub podobnych)',
}
